<template>
    <div>
        <a-card size="small" title="短信统计">
        </a-card>
        <channelSelecter  :isDisabled="false" @onChannelCodeChange="handleChannelChange"></channelSelecter>
        <a-card size="small">

            <a-form layout="inline" :form="form" class="myform" @keyup.enter.native="handleSubmit">
                <a-form-item label="业务分类">
                    <messageTypeSelecter :showAll="true" :channelcode="searchP.channelcode" @onmessagestypecodeChange="handleMessagestypecodeChange"></messageTypeSelecter>
                </a-form-item>
                <a-form-item>
                        <timeSelecter v-model="searchP.selectedTimeRange" style="margin-left:20px;"></timeSelecter>
                </a-form-item>
                <a-form-item>
                        <a-button type="primary"  @click="handleSubmit">查询</a-button>
                </a-form-item>
            </a-form>
           <chart ref="chartID"></chart>
        </a-card>
    </div>
</template>
<script>
import chart from './chart'
import timeSelecter from '../comp/timeselecter'
import messageTypeSelecter from '../../components/messageTypeSelecter'
import channelSelecter from '../../components/channelSelecter'
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            channelcode:'',
            searchP:{
                channelcode:'',
                messagestypecode:'',
                selectedTimeRange:'',
            },
        };
    },
    methods: {
        handleMessagestypecodeChange(msg){
            this.searchP.messagestypecode = msg.messagestypecode;
            this.handleSubmit();
        },
        handleChannelChange(item){
            this.searchP.channelcode = item.value;
        },
        handleSubmit(){
            this.$refs.chartID.loadData(this.searchP)
        },

    },
    components:{
        channelSelecter,
        messageTypeSelecter,
        chart,
        timeSelecter
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
